<template>
    <transition name="modal">
        <div>
            <div class="modal-mask">

                <div class="modal-wrapper" @click="$emit('close')">
                    <div class="modal-container" @click.stop="">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content" :class='{isTpg: isTpg}'>
                                <div class="modal-title">
                                    <span>Comment Now Playing</span>
                                    <div class="close-modal" @click="$emit('close')" :class='{isTpg: isTpg}'>
                                        <font-awesome-icon icon="times" aria-hidden="false" />
                                    </div>
                                </div>

                                <div class="outer-container">
                                    <div class="track-info" v-if="track">
                                        <div class="image-holder">
                                            <img :src="track.album.cover" onerror="this.onerror=null;this.src='/images/unknown-album.jpg';">
                                        </div>
                                        <div class="artist-and-title">
                                            <div class="title">
                                                <span v-if="track.title && track.title.length > 30" v-tooltip="track.name">{{ track.title }}</span>
                                                <span>{{ track.title }}</span>
                                            </div>
                                            <div class="artist">
                                                <span v-if="track.artist.name && track.artist.name.length > 30" v-tooltip="track.artist.name">{{ track.artist.name }}</span>
                                                <span>{{ track.artist.name }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <br>

                                    <div class="reasons-container" v-if="track && (track.votes.vote == 1 || track.votes.vote == 0)">
                                        <div v-for="reason in voteReasonGroup" :key="reason.name">
                                            <div class="reason-row">
                                                <div class="form-check" :class='{isTpg: isTpg}'>
                                                    <label class="form-check-label">
                                                    <input class="form-check-input" type="radio" :name="reason.name" v-model="vote_reason_id" v-bind:value="reason.vote_reason_id"> {{ reason.name }}
                                                    </label>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="comment-container" :class='{isTpg: isTpg}' v-if="track">
                                        <textarea v-model="comment" placeholder="Comment"></textarea>
                                    </div>
                                    <br>
                                    <div class="row" style="padding-bottom:20px;" v-if="track">
                                        <div class="deleteComment col-xl-5">
                                            <span @click="deleteComment" v-if="track.votes.comment || track.votes.voteReasonId">
                                                Delete
                                            </span>
                                        </div>
                                        <div class="form-submit-button col-xl-6">
                                            <input type="submit" @click="saveComment" style="color:white;margin-top:0px;">
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
  data() {
    return {
      vote_reason_id: this.track.votes.voteReasonId,
      comment: this.track.votes.comment,
    };
  },
  mounted() {

    // this.clearInfo();
  },
  props: ['vote', 'vote-reasons', 'track', 'is-tpg'],
  methods: {
    // show: function() {
    //     this.clearInfo();
    //     $('#modalVoteMenu').modal('show')
    // },
    saveComment() {
      const voteReasonAndComment = {
        selectedReasonID: this.vote_reason_id,
        comment: this.comment,
        track: this.track,
      };

      this.$emit('saveComment', voteReasonAndComment);
      this.$emit('close');
    },
    cancel() {
      this.$emit('close');
    },
    deleteComment() {
      this.$emit('deleteComment', this.track);
      this.$emit('close');
    },
    clearInfo() {
      this.vote_reason_id = '';
      this.comment = '';
    },
  },
  watch: {
    track() {
      // this.selectedReasonID = this.track.vote_reason_id;
      // this.comment = this.track.comment;

      // this.modalTrack = this.track;
      // this.comment = this.track.comment;
    },
  },
  computed: {
    voteReasonGroup() {
      if (this.track.votes.vote == '1' || this.track.votes.vote == 1) {
        return this.voteReasons.positive;
      }
      return this.voteReasons.negative;
    },
  },
};
</script>

<style scoped>
.modal-dialog {
    width: auto;
    max-width: 400px;
    margin: 0 auto;
    margin-top: 50px;
}

.modal-content {
    /* width:700px;
        margin:0 auto; */
    background: #666;
    color: white;
}

.modal-content.isTpg {
    background-color: #efefef;
    color: #3a3a3a;
}

.onboarding-container {
    text-align: left;
}

.close-modal {
    position: absolute;
    top: 0px;
    right: 10px;
    cursor: pointer;
    text-align: right;
    width: 20px;
    height: 20px;
    color: white;
}

.close-modal.isTpg {
    color: white;
}

.modal-content {
    background: rgba(72, 70, 77, .9);
    color: white;
}

.modal-content.isTpg {
    background: rgba(72, 70, 77, .9);
    color:white;
}

.modal-title {
    margin-bottom: 10px;
    border-bottom: 1px solid #666;
}

.yellow-vote-box {
    width: 120px;
    height: 30px;
    background: yellow;
    float: left;
    color: #303030;
    font-size: 16px;
    line-height: 30px;
    margin-bottom: 20px;
}

.yellow-vote-box.isTpg {
    background: rgba(1, 172, 129, 1);
    color: white;
}

.icon-holder {
    width: 32px;
    height: 32px;
    float: left;
    margin-top: -2px;
}

.track-info {
    width: 100%;
    clear: both;
    text-align: left;
    margin-top: 20px;
    margin-bottom: 30px;
}

.track-info img {
    height: 46px;
    width: 46px;
    float: left;
}

.artist-and-title {
    padding-left: 10px;
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    float: left;
    padding-top: 3px;
}

.artist-and-title div {
    line-height: 20px;
    height: 20px;
}

.title {
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.image-holder {
    width: 46px;
    float: left;
}

.outer-container {
    width: 90%;
    margin: 0 auto;
}

.reasons-container {
    margin-top: 30px;
    width: 100%;
    clear: both;
    margin-bottom: 10px;
}

.reason-row {
    width: 100%;
    text-align: left;
}

.form-check-label {
    font-size: 13px;
    color: white;
}

.form-check input[type='radio'] {
    border: 1px solid #fff;
}

.form-check input[type='radio']:checked:before {
    background: yellow;
}

.form-check.isTpg input[type='radio']:checked:before {
    background: rgba(1, 172, 129, 1);
}

.comment-container {
    margin-top: 20px;
    margin-bottom: 10px;
}

.comment-container textarea {
    border: 0px solid #ccc;
    width: 100%;
    margin: 0 auto;
    margin-top: 10px;
    color: #efefef;
    resize: vertical;
    background-color: rgba(27, 27, 27, 0.5);
}

.comment-container.isTpg textarea {
    background-color: #ccc;
    color: black
}

.deleteComment {
    text-align: left;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-top:-5px;
}

.deleteComment span {
    cursor: pointer;
}

.deleteComment span:hover {
    color: #ccc;
}
</style>
